/// <amd-module name="Wit/BacklogsHub/Common/BacklogHubContants" />
export namespace Content {
    export const DirectoryZeroDataPng = "ms.vss-work-web/new-backlogs-hub-content/content/no-results.png";
    export const NoWorkZeroDataSvg = "ms.vss-work-web/new-backlogs-hub-content/content/no-work-scheduled.svg";
}

export namespace FavoriteScope {
    export const FavoriteArtifactScopeType = "Project";
}

export namespace Routes {
    export const BoardsHubContent = "ms.vss-work-web.team-board-content-route";
    export const WorkItemsForm = "ms.vss-work-web.work-items-form-route";
}

export namespace DataProviders {
    export const AllDirectoryDataProvider = "ms.vss-work-web.new-backlogs-hub-directory-all-data-provider";
    export const BacklogsHubContentHeaderDataProvider = "ms.vss-work-web.backlogs-hub-content-header-data-provider";
    export const BacklogLevelWorkItemDataProvider = "ms.vss-work-web.backlog-level-work-item-data-provider";
    export const CurrentTeam = "ms.vss-tfs-web.team-context-data-provider";
    export const DirectoryDataProvider = "ms.vss-work-web.new-backlogs-hub-directory-data-provider";
}

export enum WorkItemLinks {
    Parent = "System.LinkTypes.Hierarchy-Reverse"
}
